"use strict";

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mark_1 = require("./mark");

var specification_1 = require("../../specification");

var DEFAULT_EMPHASIS_DESATURATION = {
  saturation: {
    multiply: 0.2
  },
  lightness: {
    add: 0.01,
    pow: 0.2
  }
};
var DEFAULT_EMPHASIS_STROKE_COLOR = {
  r: 255,
  g: 0,
  b: 0
};
var DEFAULT_EMPHASIS_STROKE_WIDTH = 1;
/**
 * Represents a mark class that is emphasizable
 */

var EmphasizableMarkClass =
/*#__PURE__*/
function (_mark_1$MarkClass) {
  _inherits(EmphasizableMarkClass, _mark_1$MarkClass);

  function EmphasizableMarkClass(parent, object, state) {
    var _this;

    var defaultMethod = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : specification_1.EmphasisMethod.Saturation;

    _classCallCheck(this, EmphasizableMarkClass);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EmphasizableMarkClass).call(this, parent, object, state));
    _this.defaultMethod = defaultMethod;
    return _this;
  }
  /**
   * Generates styling info for styling emphasized marks
   * @param emphasize If true, emphasis will be applied.
   */


  _createClass(EmphasizableMarkClass, [{
    key: "generateEmphasisStyle",
    value: function generateEmphasisStyle(emphasize) {
      // If emphasize is undefined (or true), we use full saturation
      var style = {
        saturation: 1
      }; // only if emphasize is explicitly false to we use saturation of .7

      var method = this.object.properties.emphasisMethod || this.defaultMethod;

      if (method === specification_1.EmphasisMethod.Saturation && emphasize === false) {
        style.colorFilter = DEFAULT_EMPHASIS_DESATURATION;
      }

      if (method === specification_1.EmphasisMethod.Outline && emphasize) {
        style.strokeColor = DEFAULT_EMPHASIS_STROKE_COLOR;
        style.strokeWidth = DEFAULT_EMPHASIS_STROKE_WIDTH;
      }

      return style;
    }
  }]);

  return EmphasizableMarkClass;
}(mark_1.MarkClass);

exports.EmphasizableMarkClass = EmphasizableMarkClass;